<script setup lang="ts">
const { waitUntilAppLoaded } = useNavigation()
const { cacheState } = useCache()
const { createNewWindowWithResource } = useTauri()
const { createGlobalRegistry } = useGlobalRegistry()

useHead({
  htmlAttrs: { class: "desktop-html" },
  bodyAttrs: { class: "desktop-body" },
})

const isLoading = computed(() => !cacheState.value.anonId && !cacheState.value.userId)

// prevent navigation and instead launching a new window with the URL
addRouteMiddleware(
  "page_view",
  (to) => {
    console.warn("Opening in new poly window", to)
    createNewWindowWithResource(to.fullPath)
    return abortNavigation()
  },
  { global: true },
)

onMounted(async () => {
  if (!isDesktop())
    navigateTo("/")

  createGlobalRegistry()
  await waitUntilAppLoaded()
})
</script>

<template>
  <loading-startup-screen v-if="isLoading" />
  <slot v-else />
</template>

<style lang="sass">
@import '~/assets/styles/generated/variables.sass'

.desktop-html
  @apply text-base text-[#{$global-t-default}] bg-transparent h-full w-full

.desktop-body
  @apply h-full w-full
  // for some reason the inner div inside of body isn't taking up the full width?
  &>div
    @apply h-full w-full
</style>
